import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import useWindowLocationHref from '../../platformui/Hooks/useWindowLocation';
import Modal, {
  CloseModalButton,
  ModalPanel,
  OpenModalButton,
} from '../../platformui/Modal';

const LetterSlideLabelTooltip = ({
  tooltipLinkText,
  tooltipText,
  translations,
}) => {
  const [positionTop, setPositionTop] = useState(false);
  const positionRef = useRef(null);
  const tooltipContentRef = useRef(null);
  const href = useWindowLocationHref();

  useEffect(() => {
    if (positionRef.current) {
      const rect = positionRef.current.getBoundingClientRect();
      const viewportMiddle = window.innerHeight / 2;
      setPositionTop(rect.top > viewportMiddle);
    }
  }, []);

  return (
    <Modal noScroll={false}>
      <div
        data-event-category={href || 'novalue'}
        data-event-action={tooltipLinkText}
        data-event-name={tooltipText}
        className="c-letter-slide__modal__container"
      >
        <OpenModalButton
          open="c-letter-slide"
          id="c-letter-slide"
          className="c-letter-slide__modal-open"
          ariaLabel={tooltipLinkText}
          clickCallback={() => {
            setTimeout(() => {
              tooltipContentRef.current?.focus();
            }, 0);
          }}
        >
          <span
            ref={positionRef}
            data-event-include
            className="c-letter-slide__modal-open__icon"
          />
          <p data-event-include className="c-letter-slide__modal-open__link">
            {tooltipLinkText}
          </p>
        </OpenModalButton>
        <ModalPanel whenActive="c-letter-slide">
          <div
            className={classNames('c-letter-slide__modal-panel', {
              'c-letter-slide__modal-panel--position-top': positionTop,
            })}
          >
            <CloseModalButton className="c-letter-slide__modal-close">
              <span className="show-for-sr">
                {translations?.close || 'stäng'}
              </span>
            </CloseModalButton>
            <div
              ref={tooltipContentRef}
              tabIndex={0}
              className="c-letter-slide__modal-panel__content"
            >
              <div
                className="c-letter-slide__modal-panel__description"
                dangerouslySetInnerHTML={{
                  __html: tooltipText,
                }}
              />
            </div>
          </div>
        </ModalPanel>
      </div>
    </Modal>
  );
};

export default LetterSlideLabelTooltip;
